import pagePart         from '../part/pagePart'
import appHelper        from "@util/appHelper";
import consoleHelper    from "@util/consoleHelper";
import wechatHelper     from "@util/wechatHelper";

// data api
import clientLogApi     from "@api/clientLog";
import storageManager   from "@comp/platformApi/storageManager";
import consoleApi       from "@comp/platformApi/consoleApi";
import userUtil from "@comp/shixunApp/userUtil";
import appConfig from "@/appConfig";

/**
 * 师讯平台页面零件
 * @description     页面继承该类，可以自动设置微信分享，另外还包含一些师讯平台特有的功能
 * @module          shixunApp/shixunPagePart
 * @extends         part/pagePart
 */
export default {

    extends : pagePart,

    data() {
        return {
            /**
             * page key
             * @type    {String}
             * @description 用于用户行为分析
             */
            pageKey : '',

            clientLogId : ''
        }
    },

    methods : {

        /**
         * 奇葩设计，硬要回到前一个页面
         */
        back : function () {
            consoleApi.log('[shixunPagePart] 邬总的需求：返回前一个页面，而不是返回上一级。');
            appHelper.back(this);
        },

        /**
         * @method  setWechatShare
         */
        setWechatShare : function(options = {}) {

            const me = this;

            appHelper.checkLogin((error, result) => {

                let wechatShareOptions = {
                    title   : options.title || appHelper.getTitle(),
                    desc    : options.desc || appConfig.wechat.defaultDescription,
                    // link    : location.href,
                    link    : '',
                    imgUrl  : options.imgUrl || appHelper.getAppIcon() // 分享图标
                };

                // default params
                let shareParams = {
                    routePath: me.$route.path,
                    routeParams: me.$route.params,
                    urlParams : {}
                };

                if (result)
                {
                    shareParams.urlParams.promotionCode = result.introduceCode;
                }

                wechatShareOptions.link = appHelper.generateShareUrl('/share/' + encodeURIComponent(JSON.stringify(shareParams)));

                // consoleHelper.log('');
                // consoleHelper.log('[wechat] wechatShareOptions:');
                // consoleHelper.log(wechatShareOptions);
                wechatHelper.setShare(wechatShareOptions);
            });
        },

        /**
         * 奇葩设计，硬要在网页上搞一个分享按钮
         */
        share() {
            consoleHelper.log('[shixunPagePart] 邬总坚持要保留的按钮，网页端只能引导用户操作。');
            appHelper.showHint("点击右上角进行分享！")
        },

        sharePoster() {
            if (typeof(this.$refs.shareDrawer) === 'undefined')
            {
                this.share();
                return;
            }

            this.$refs.shareDrawer.init({
                id: this.dataItem[this.primaryKey]
            });
        }
    },
    mounted () {
        // consoleHelper.log('[page] page mounted.');

        if (this.title)
        {
            this.setWechatShare();
        }

        // 添加一个页面访问记录
        if (this.pageKey)
        {
            let clientLogId = storageManager.getItem('clientLogId');

            let data = {
                pageKey : this.pageKey,
                pageName : this.title,
                pageRoute : this.$route.fullPath
            };
            clientLogId ? data.PId = clientLogId : null;

            clientLogApi.add(data, (data) => {
                this.clientLogId = data;
                storageManager.setItem('clientLogId', this.clientLogId);
            });
        }
    },
    destroyed() {
        // consoleHelper.log('[shixunPagePart] page destroyed.');

        // 更新最后的访问时间
        if (this.pageKey)
        {
            let clientLogId = storageManager.getItem('clientLogId');

            if (clientLogId)
            {
                clientLogApi.update(clientLogId);
            }

        }
    }

}
